import React, { Fragment, useEffect, useState } from "react";
import "./dashboard.scss";
import { useNavigate } from "react-router-dom";
import { Card } from "react-bootstrap";
import { dashboardcount } from "../../services/admin";
import StaffLocationMap from "./StaffLocationMap";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
function Dashboard() {
  const navigate = useNavigate();
  const [dcount, setDCount] = useState("");
  const [reportData, setReportData] = useState([]);
  const [wreportData, setWReportData] = useState([]);

  const [dayrep, setDayRep] = useState([]);
  const [collrep, setCollRep] = useState([]);
  const [cpath, setCPath] = useState("");

  useEffect(() => {

    const fetchData = () => {
      setCollRep([]);
      setDCount([]);
      setReportData([]);
      setDayRep([]);
      const temp = new FormData();
      temp.append("branch", localStorage.getItem("branch"));
      dashboardcount(temp).then((res) => {
        if (res.status === true) {
          setDCount(res.data.counts);
          setReportData(res.data.report);
          setWReportData(res.data.weekly_report);
          setDayRep(res.data.dayreport);
          setCPath(res.data.path);
          setCollRep(res.data.collectionreport);
        }
      });
    };
    fetchData();
    const intervalId = setInterval(fetchData, 300000);
    return () => clearInterval(intervalId);
  }, []);
  let isCloned = false; // Flag to track if the list has already been cloned

  const startAutoScroll = () => {
    const scrollContainer = document.getElementById('auto-scroll');
    const announcementList = document.getElementById('announcement-list');



    const scrollSpeed = 1; // Pixels per step

    if (scrollContainer) {
      // Start the scrolling interval
      window.scrollInterval = setInterval(() => {
        // Scroll the container by 1px
        scrollContainer.scrollTop += scrollSpeed;

        // Reset scroll position when reaching the end of the first list
        if (scrollContainer.scrollTop >= announcementList.scrollHeight) {
          scrollContainer.scrollTop = 0;
        }
      }, 30); // Interval in milliseconds
    }
  };

  // Stop auto scroll
  const stopAutoScroll = () => {
    clearInterval(window.scrollInterval);
    isCloned = false;  // Reset the clone flag when stopping the auto-scroll
  };


  // Start auto-scrolling on page load
  document.addEventListener('DOMContentLoaded', startAutoScroll);
  const startBirthdayScroll = () => {
    const scrollContainer = document.getElementById('birthday-scroll');
    const birthdayList = document.getElementById('birthday-list');

    // Duplicate the list for seamless scrolling
    if (!birthdayList.classList.contains('duplicated')) {
      const clone = birthdayList.cloneNode(true);
      clone.id = '';
      clone.classList.add('duplicate');
      scrollContainer.appendChild(clone);
      birthdayList.classList.add('duplicated');
    }

    const scrollSpeed = 1; // Pixels per step

    if (scrollContainer) {
      window.scrollInterval = setInterval(() => {
        scrollContainer.scrollTop += scrollSpeed;

        // Reset scroll position when reaching the end of the first list
        if (scrollContainer.scrollTop >= birthdayList.scrollHeight) {
          scrollContainer.scrollTop = 0;
        }
      }, 30); // Interval in milliseconds
    }
  };

  // Start auto-scrolling on page load
  document.addEventListener('DOMContentLoaded', startBirthdayScroll);

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const labels = reportData.map(
    (data) => `${monthNames[data.month - 1]}, ${data.year}`
  );

  const data = {
    labels,
    datasets: [
      {
        label: "Principal",
        data: reportData.map((data) => data.total_principle),
        backgroundColor: "#4CAF50",
      },
      {
        label: "Interest",
        data: reportData.map((data) => data.total_interest),
        backgroundColor: "#2196F3",
      },
      {
        label: "Collection Amount",
        data: reportData.map((data) => data.total_paidamount || 0),
        backgroundColor: "#FFC107",
      },
      {
        label: "Loan Amount Given",
        data: reportData.map((item) => item.loan_amount_given),
        backgroundColor: "#FF5722",
      },
    ],
  };



  // const mratio = window.innerWidth < 768 ? true : false;
  const options = {
    plugins: {
      title: {
        display: true,
        text: "MONTHLY REPORT",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      legend: {
        position: "top",
      },
    },
    responsive: true,
    maintainAspectRatio: true,
    // aspectRatio: aspectRatio,
    scales: {
      x: {
        stacked: true,
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: "Amount in Rs",
        },
      },
    },
  };



  const weekdata = {
    labels: wreportData.map(item => `Week ${item.week} (${item.from_date} - ${item.to_date})`), // X-axis labels (weeks)
     
    datasets: [
      {
        label: "Principal",
        data: wreportData.map((data) => data.total_principle),
        backgroundColor: "#4CAF50",
        stack: 'Stack 0', // Enable stacking
      },
      {
        label: "Interest",
        data: wreportData.map((data) => data.total_interest),
        backgroundColor: "#2196F3",
        stack: 'Stack 0', // Enable stacking
      },
      {
        label: 'Loan Amount',
        data: wreportData.map(item => item.total_amount),
        backgroundColor: '#FFC107',
        stack: 'Stack 0', // Enable stacking
      },
      {
        label: 'Collection Amount',
        data: wreportData.map(item => item.total_paidamount),
        backgroundColor: '#FF5722',
        stack: 'Stack 0', // Use the same stack ID
        minBarLength: 5,  // Forces the 600 to be visible as a small sliver
      },
    ],
  };

  const woptions = {
    plugins: {
      title: {
        display: true,
        text: "WEEKLY REPORT",
      },
      tooltip: {
        mode: "index",
        intersect: false,
      },
      legend: {
        position: "top",
      },
    },
    responsive: true,
    maintainAspectRatio: true,
    scales: {
      x: { stacked: true },
      y: {
        stacked: true,
        // beginAtZero: true,
        title: { display: true, text: 'Amount (Rs)' }
      }
    }
  };



  const chartData = {
    labels: dayrep.map(item => item.day), // X-axis labels (days)
    datasets: [
      {
        label: 'Loan Amount',
        data: dayrep.map(item => item.total_amount), // Y-axis data for total_amount
        backgroundColor: 'rgba(75, 192, 192, 0.5)', // Color for the bars
        borderColor: 'rgba(75, 192, 192, 1)', // Border color for the bars
        borderWidth: 1,
      },
      {
        label: 'Collection Amount',
        data: dayrep.map(item => item.total_paidamount), // Y-axis data for total_paidamount
        backgroundColor: 'rgba(153, 102, 255, 0.5)', // Different color for paid amount
        borderColor: 'rgba(153, 102, 255, 1)',
        borderWidth: 1,
      },
    ],
  };

  const doptions = {
    type: 'bar',
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      title: {
        display: false,
        text: 'Day-wise Total Amount vs Total Paid Amount',
      },
      tooltip: {
        mode: 'index',
        intersect: false,
      },
      legend: {
        position: 'top',
      },
    },
    scales: {
      x: {
        title: {
          display: false,
          text: 'Day (Jan)',
        },
      },
      y: {
        title: {
          display: true,
          text: 'Amount (Rs)',
        },
      },
    },
  };

  return (
    <Fragment>
      <div className="main-container container-fluid">
        <div className="inner-body">
          {/* Page Header */}
          <div className="page-header">
            <h2 className="main-content-title tx-24 mg-b-5">
              Welcome To Dashboard
            </h2>
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a>Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Dashboard
              </li>
            </ol>
          </div>
          {/* End Page Header */}

        
          {/* Attendance Quick Link for field roles (everyone except Super Admin=1 and Admin=2) */}
          {localStorage.getItem("Role") !== "1" && localStorage.getItem("Role") !== "2" &&
            <div className="row row-sm">
              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="card custom-card bg-primary-gradient">
                  <div className="card-body">
                    <div className="d-flex align-items-center justify-content-between">
                      <div>
                        <h4 className="text-white mb-2">Attendance</h4>
                        <p className="text-white-50 mb-0">Mark your clock in/out and upload vehicle KM readings</p>
                      </div>
                      <div>
                        <button
                          className="btn btn-white btn-lg"
                          onClick={() => navigate('/attendance/clockinout')}
                        >
                          <i className="fa fa-clock-o me-2"></i>
                          Clock In / Clock Out
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          }

          {/*Row*/}
          {/* <div className="row row-sm">
            <div className="col-sm-12 col-lg-12 col-xl-12"> */}
          <div className="row row-sm">
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card custom-card-a">
                <div className="card-body">
                  <div className="card-item">
                    <div className="card-item-icon card-icon">
                      <img
                        alt="avatar"
                        className=""
                        src={require("../../assets/images/icons/app loan.png")}
                      />
                    </div>
                    <div className="card-item-title mb-2">
                      <label className="main-content-label tx-13 font-weight-bold mb-1">Total Active Loans</label>
                    </div>
                    <div className="card-item-body">
                      <div className="card-item-stat">
                        <h6 className="font-weight-bold">{dcount !== "" ? dcount.totalloancount : "0"}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <div className="card custom-card custom-card-b">
                <div className="card-body">
                  <div className="card-item">
                    <div className="card-item-icon card-icon">
                      <img
                        alt="avatar"
                        className=""
                        src={require("../../assets/images/icons/closed loan white.png")}
                      />
                    </div>
                    <div className="card-item-title mb-2">
                      <label className="main-content-label tx-13 font-weight-bold mb-1">Total Closed Loan</label>
                    </div>
                    <div className="card-item-body">
                      <div className="card-item-stat">
                        <h6 className="font-weight-bold">{dcount !== "" ? dcount.closedloancount : "0"}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3">
              <div className="card custom-card custom-card-c">
                <div className="card-body">
                  <div className="card-item">
                    <div className="card-item-icon card-icon">
                      <img
                        alt="avatar"
                        className=""
                        src={require("../../assets/images/icons/group loan.png")}
                      />
                    </div>
                    <div className="card-item-title  mb-2">
                      <label className="main-content-label tx-13 font-weight-bold mb-1">Total Groups</label>
                    </div>
                    <div className="card-item-body">
                      <div className="card-item-stat">
                        <h6 className="font-weight-bold">{dcount !== "" ? dcount.groupcount : "0"}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {localStorage.getItem("Role") !== "4" &&

              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <div className="card custom-card custom-card-d">
                  <div className="card-body">
                    <div className="card-item">
                      <div className="card-item-icon card-icon">
                        <img
                          alt="avatar"
                          className=""
                          src={require("../../assets/images/icons/principal balance.png")}
                        />
                      </div>
                      <div className="card-item-title  mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">Total Loan to Members</label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h6 className="font-weight-bold">₹ {dcount !== "" ? dcount.principal : "0"}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {/* <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3">
                  <div className="card custom-card custom-card-e">
                    <div className="card-body">
                      <div className="card-item">
                        <div className="card-item-icon card-icon">
                          <img
                            alt="avatar"
                            className=""
                            src={require("../../assets/images/icons/Cash-in-hand.png")}
                          />
                        </div>
                        <div className="card-item-title  mb-2">
                          <label className="main-content-label tx-13 font-weight-bold mb-1">Cash In Hand CURRENT</label>
                        </div>
                        <div className="card-item-body">
                          <div className="card-item-stat">
                            <h4 className="font-weight-bold">₹ 8,500</h4>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div> */}
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3">
              <div className="card custom-card custom-card-f">
                <div className="card-body">
                  <div className="card-item">
                    <div className="card-item-icon card-icon">
                      <img
                        alt="avatar"
                        className=""
                        src={require("../../assets/images/icons/collection center.png")}
                      />
                    </div>
                    <div className="card-item-title  mb-2">
                      <label className="main-content-label tx-13 font-weight-bold mb-1">TODAY COLLECTION GROUP</label>
                    </div>
                    <div className="card-item-body">
                      <div className="card-item-stat">
                        <h6 className="font-weight-bold">{dcount !== "" ? dcount.loanGroupCount : "0"}</h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {localStorage.getItem("Role") !== "4" &&

              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <div className="card custom-card custom-card-g">
                  <div className="card-body">
                    <div className="card-item">
                      <div className="card-item-icon card-icon">
                        <img
                          alt="avatar"
                          className=""
                          src={require("../../assets/images/icons/today collection.png")}
                        />
                      </div>
                      <div className="card-item-title  mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">TODAY COLLECTION</label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h6 className="font-weight-bold">₹ {dcount !== "" ? dcount.paidamount : "0"}/₹ {dcount !== "" ? dcount.totalamount : "0"}</h6>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {localStorage.getItem("Role") !== "4" &&
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <div className="card custom-card custom-card-h">
                  <div className="card-body">
                    <div className="card-item">
                      <div className="card-item-icon card-icon">
                        <img
                          alt="avatar"
                          className=""
                          src={require("../../assets/images/icons/loan sanction.png")}
                        />
                      </div>
                      <div className="card-item-title  mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">TODAY LOAN DISBURSEMENT</label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h6 className="font-weight-bold">₹ {dcount !== "" ? dcount.todayloancount : "0"}</h6>

                          {/* <small><b className="text-danger">12%</b> decrease</small> */}
                        </div>``
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            {localStorage.getItem("Role") !== "4" &&
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3">
                <div className="card custom-card custom-card-e">
                  <div className="card-body">
                    <div className="card-item">
                      <div className="card-item-icon card-icon">
                        <img
                          alt="avatar"
                          className=""
                          src={require("../../assets/images/icons/Cash-in-hand.png")}
                        />
                      </div>
                      <div className="card-item-title  mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">TODAY INTEREST</label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h6 className="font-weight-bold">₹ {dcount !== "" ? (dcount.totalamount - dcount.principal) : "0"}</h6>

                          {/* <small><b className="text-danger">12%</b> decrease</small> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            }
            <div className="col-sm-12 col-md-12 col-lg-6 col-xl-3">
              <div className="card custom-card" style={{ backgroundColor: '#6259ca', color: 'white' }} onClick={() => navigate('/joballocation')} role="button">
                <div className="card-body">
                  <div className="card-item">
                    <div className="card-item-icon card-icon">
                      {/* <i className="fa fa-tasks fa-3x" style={{color: 'white'}}></i> */}
                    </div>
                    <div className="card-item-title  mb-2">
                      <label className="main-content-label tx-13 font-weight-bold mb-1" style={{ color: 'white' }}>JOB ALLOCATIONS</label>
                    </div>
                    <div className="card-item-body">
                      <div className="card-item-stat">
                        <h6 className="font-weight-bold" style={{ color: 'white' }}>
                          Pending: {dcount !== "" ? dcount.pendingJobAllocations : "0"} |
                          In Progress: {dcount !== "" ? dcount.inProgressJobAllocations : "0"}
                        </h6>
                        <small>Click to view all allocations</small>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {localStorage.getItem("Role") !== "4" &&
            <>
              <div className="row row-sm">
                {/* <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <Card className="custom-card">
                    <Card.Header>
                      <div className="card-header border-bottom-0 pb-0">
                        <label className="main-content-label mb-2 pt-1">Daily Recent Collection</label>
                      </div>
                    </Card.Header>
                    <Card.Body
                      id="auto-scroll"
                      // onMouseEnter={() => stopAutoScroll()}
                      // onMouseLeave={startAutoScroll}
                      style={{
                        maxHeight: '350px',
                        overflowY: 'auto',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <ul
                        className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                        id="announcement-list"
                      >
                        {collrep.map((item, index) => (
                          <li key={index} className="d-flex align-items-center mb-3">
                            <div className="flex-shrink-0">
                              <div className="main-avatar avatar-md online"></div>
                            </div>
                            <div className="ms-3 flex-grow-1">
                              <p className="tx-16 text-dark mb-0 tx-semibold">{item.member_name}</p>
                              <p className="mb-0 text-muted">{item.staff_name}</p>
                            </div>
                            <a className="me-2 mt-1"><span className={item.loan_paiddate === null ? "badge bg-danger-light" : "badge bg-success-light"}>{item.loan_paiddate !== null ? "Collected" : "Not Collected"}</span></a>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-6 col-xl-6">
                  <Card className="custom-card">
                    <Card.Header>
                      <div className="card-header border-bottom-0 pb-0">
                        <label className="main-content-label mb-2 pt-1">Monthly Recent Collection</label>
                      </div>
                    </Card.Header>
                    <Card.Body
                      id="auto-scroll"
                      // onMouseEnter={() => stopAutoScroll()}
                      // onMouseLeave={startAutoScroll}
                      style={{
                        maxHeight: '350px',
                        overflowY: 'auto',
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                      }}
                    >
                      <ul
                        className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                        id="announcement-list"
                      >
                        {collrep.map((item, index) => (
                          <li key={index} className="d-flex align-items-center mb-3">
                            <div className="flex-shrink-0">
                              <div className="main-avatar avatar-md online"></div>
                            </div>
                            <div className="ms-3 flex-grow-1">
                              <p className="tx-16 text-dark mb-0 tx-semibold">{item.member_name}</p>
                              <p className="mb-0 text-muted">{item.staff_name}</p>
                            </div>
                            <a className="me-2 mt-1"><span className={item.loan_paiddate === null ? "badge bg-danger-light" : "badge bg-success-light"}>{item.loan_paiddate !== null ? "Collected" : "Not Collected"}</span></a>
                          </li>
                        ))}
                      </ul>
                    </Card.Body>
                  </Card>
                </div> */}
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="card custom-card mg-b-20">
                    <Card className="custom-card">
                      <Card.Header className="">
                        <div className="card-header border-bottom-0 pb-0">
                          <label className="main-content-label mb-2 pt-1">Monthly Report</label>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Bar options={options} data={data} />
                      </Card.Body>
                    </Card>
                  </div>
                </div>
                <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <div className="card custom-card mg-b-20">
                    <Card className="custom-card">
                      <Card.Header className="">
                        <div className="card-header border-bottom-0 pb-0">
                          <label className="main-content-label mb-2 pt-1">Weekly Report</label>
                        </div>
                      </Card.Header>
                      <Card.Body>
                        <Bar options={woptions} data={weekdata} />
                      </Card.Body>
                    </Card>
                  </div>
                </div>

              </div>
              <div className="row row-sm">
                <div className="card custom-card mg-t-40 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                  <Card className="custom-card">
                    <Card.Header className="">
                      <div className="card-header border-bottom-0 pb-0">
                        <label className="main-content-label mb-2 pt-1">Daywise report</label>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <Bar data={chartData} options={doptions} />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </>
          }
          {localStorage.getItem("Role") === "4" &&
            <div className="row row-sm">

              <div className="col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div className="card custom-card mg-b-20">
                  <Card className="custom-card">
                    <Card.Header className="">
                      <div className="card-header border-bottom-0 pb-0">
                        <label className="main-content-label mb-2 pt-1">Daywise report</label>
                      </div>
                    </Card.Header>
                    <Card.Body>
                      <Bar data={chartData} options={doptions} />
                    </Card.Body>
                  </Card>
                </div>
              </div>
              <div className="col-sm-12 col-md-12 col-lg-6 col-xl-4">
                <Card className="custom-card">
                  <Card.Header>
                    <div className="card-header border-bottom-0 pb-0">
                      <label className="main-content-label mb-2 pt-1">Recent Collection</label>
                    </div>
                  </Card.Header>
                  <Card.Body
                    id="auto-scroll"
                    onMouseEnter={() => stopAutoScroll()}
                    onMouseLeave={startAutoScroll}
                    style={{
                      maxHeight: '350px',
                      overflow: 'hidden',
                      position: 'relative',
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <ul
                      className="visitor mb-0 d-block users-images list-unstyled list-unstyled-border"
                      id="announcement-list"
                    >
                      {collrep.map((item, index) => (
                        <li key={index} className="d-flex align-items-center mb-3">
                          <div className="flex-shrink-0">
                            <div className="main-avatar avatar-md online"></div>
                          </div>
                          <div className="ms-3 flex-grow-1">
                            <p className="tx-16 text-dark mb-0 tx-semibold">{item.member_name}</p>
                            <p className="mb-0 text-muted">{item.staff_name}</p>
                          </div>
                          <a className="me-2 mt-1"><span className={item.loan_paiddate === null ? "badge bg-danger-light" : "badge bg-success-light"}>{item.loan_paiddate !== null ? "Collected" : "Not Collected"}</span></a>
                        </li>
                      ))}
                    </ul>
                  </Card.Body>
                </Card>
              </div>
            </div>

          }
            {/* Staff location tracking — office roles (Super Admin=1, Admin=2, Manager=3) */}
          {["1", "2", "3"].includes(localStorage.getItem("Role")) && <StaffLocationMap />}

          {/* </div>
          </div> */}
          {/* Row end */}
        </div>
      </div>
    </Fragment>
  );
}

Dashboard.propTypes = {};

Dashboard.defaultProps = {};

export default Dashboard;
